import * as React from 'react'

interface Props {
  children: JSX.Element
  onHover: (hover: boolean) => void
}

const Hoverable = ({ children, onHover }: Props) => {
  const onMouseEnter = () => onHover(true)
  const onMouseLeave = () => onHover(false)

  return React.cloneElement(React.Children.only(children), {
    onMouseEnter,
    onMouseLeave,
  })
}

export default Hoverable
